<template>
  <section class="free-plan" aria-labelledby="free-plan-title">
    <span class="free-plan-eyebrow">Free plan · €0 forever</span>
    <h2 id="free-plan-title" class="free-plan-title">You scored {{ formattedScore }}. What's your conversion rate?</h2>
    <p class="free-plan-text">Add one tag to this form and see how many visitors start, finish and give up, and what that costs you.</p>
    <dl class="free-plan-tiles">
      <div v-for="metric in metrics" :key="metric" class="free-plan-tile">
        <dt>{{ metric }}</dt>
        <dd><span aria-hidden="true">??%</span><span class="visually-hidden">Unknown until you add the tag</span></dd>
      </div>
    </dl>
    <div class="free-plan-actions">
      <a :href="signupUrl" target="_blank" rel="noopener" class="ex-btn ex-btn--primary ex-btn--medium">
        <span class="ex-btn__label" data-label="Create free account">Create free account</span>
      </a>
      <span class="free-plan-note">Free forever · 1 form · up to 10,000 visits a month · no credit card</span>
    </div>
  </section>
</template>

<script>
import { formatScore } from '../score/report.mjs'
import { SIGNUP_URL } from '../score/links'

export default {
  name: 'FreePlanCard',
  props: {
    score: { type: [Number, String], required: true }
  },
  data () {
    return { signupUrl: SIGNUP_URL, metrics: ['Start rate', 'Completion', 'Error rate'] }
  },
  computed: {
    formattedScore () {
      return formatScore(this.score)
    }
  }
}
</script>

<style scoped>
.free-plan {
  padding: 32px;
  border: 1px solid var(--ex-color-hairline);
  border-radius: var(--ex-radius-panel-large);
  background: var(--ex-color-white);
}

.free-plan-eyebrow {
  font-size: 13px;
  font-weight: 600;
  color: var(--ex-color-blue);
}

.free-plan-title {
  margin-top: 10px;
  font-size: 26px;
  letter-spacing: -0.02em;
}

.free-plan-text {
  margin-top: 8px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--ex-color-neutral-700);
}

.free-plan-tiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 18px 0 0;
}

.free-plan-tile {
  padding: 14px;
  border-radius: var(--ex-radius-tile);
  background: var(--ex-color-surface-blue);
}

.free-plan-tile dt {
  font-size: 12px;
  color: var(--ex-color-neutral-500);
}

.free-plan-tile dd {
  margin: 4px 0 0;
  font-family: var(--ex-font-heading);
  font-size: 24px;
  font-weight: 600;
  color: var(--ex-color-neutral-300);
}

.free-plan-actions {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
}

.free-plan-note {
  font-size: 13px;
  color: var(--ex-color-neutral-500);
}

@media (max-width: 640px) {
  .free-plan {
    padding: 24px;
  }

  .free-plan-actions {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
